function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M424,352h16c4.4,0,8-3.6,8-8V104c0-4.4-3.6-8-8-8h-16c-4.4,0-8,3.6-8,8v240C416,348.4,419.6,352,424,352z  M328,352h16c4.4,0,8-3.6,8-8V200c0-4.4-3.6-8-8-8h-16c-4.4,0-8,3.6-8,8v144C320,348.4,323.6,352,328,352z M136,352h16 c4.4,0,8-3.6,8-8v-80c0-4.4-3.6-8-8-8h-16c-4.4,0-8,3.6-8,8v80C128,348.4,131.6,352,136,352z M232,352h16c4.4,0,8-3.6,8-8V136 c0-4.4-3.6-8-8-8h-16c-4.4,0-8,3.6-8,8v208C224,348.4,227.6,352,232,352z M504,416H32V72c0-4.4-3.6-8-8-8H8c-4.4,0-8,3.6-8,8v360 c0,8.8,7.2,16,16,16h488c4.4,0,8-3.6,8-8v-16C512,419.6,508.4,416,504,416z"
});

var SvgIconPriceChart = function SvgIconPriceChart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconPriceChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_price_chart.4457ec1b.svg";
export { ForwardRef as ReactComponent };